import { render, staticRenderFns } from "./ArticleListModal.vue?vue&type=template&id=bb5b3fc6&"
import script from "./ArticleListModal.vue?vue&type=script&lang=js&"
export * from "./ArticleListModal.vue?vue&type=script&lang=js&"
import style0 from "./ArticleListModal.vue?vue&type=style&index=0&id=bb5b3fc6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports